import React, { useState, useEffect } from "react";
import "./Work.css";
import Title from "../Title/title";

// Импорт изображений
import brow1 from "../../Photo/gallery/brows/img (1).JPEG";
import brow2 from "../../Photo/gallery/brows/img (2).JPEG";
import brow3 from "../../Photo/gallery/brows/img (3).JPEG";
import brow4 from "../../Photo/gallery/brows/img (4).JPEG";
import brow5 from "../../Photo/gallery/brows/img (5).JPEG";
import brow6 from "../../Photo/gallery/brows/img (6).JPEG";
import brow7 from "../../Photo/gallery/brows/img (7).JPEG";

import browsPmu1 from "../../Photo/gallery/brows-pmu/img  (10).jpg";
import browsPmu2 from "../../Photo/gallery/brows-pmu/img  (1).JPEG";
import browsPmu3 from "../../Photo/gallery/brows-pmu/img  (1).JPG";
import browsPmu4 from "../../Photo/gallery/brows-pmu/img  (12).jpg";
import browsPmu5 from "../../Photo/gallery/brows-pmu/img  (2).JPEG";
import browsPmu6 from "../../Photo/gallery/brows-pmu/img  (2).JPG";
import browsPmu7 from "../../Photo/gallery/brows-pmu/img  (3).JPEG";
import browsPmu8 from "../../Photo/gallery/brows-pmu/img  (3).JPG";
import browsPmu9 from "../../Photo/gallery/brows-pmu/img  (4).JPEG";

import interlash1 from "../../Photo/gallery/interlash/img  (1).JPG";
import interlash2 from "../../Photo/gallery/interlash/img  (2).JPG";
import interlash3 from "../../Photo/gallery/interlash/img  (3).JPG";
import interlash4 from "../../Photo/gallery/interlash/img  (4).JPG";

import lash1 from "../../Photo/gallery/lashes/img  (1).JPEG";
import lash2 from "../../Photo/gallery/lashes/img  (2).JPEG";
import lash3 from "../../Photo/gallery/lashes/img  (3).JPEG";
import lash4 from "../../Photo/gallery/lashes/img  (4).JPEG";
import lash5 from "../../Photo/gallery/lashes/img  (5).JPEG";

import lips1 from "../../Photo/gallery/lips/img  (10).jpg";
import lips2 from "../../Photo/gallery/lips/img  (1).JPEG";
import lips3 from "../../Photo/gallery/lips/img  (1).JPG";
import lips4 from "../../Photo/gallery/lips/img  (12).jpg";
import lips5 from "../../Photo/gallery/lips/img  (2).JPEG";
import lips6 from "../../Photo/gallery/lips/img  (3).JPEG";
import lips7 from "../../Photo/gallery/lips/img  (4).JPEG";

import tattooCover1 from "../../Photo/gallery/tattoo-cover/img  (1).JPEG";
import tattooCover2 from "../../Photo/gallery/tattoo-cover/img  (1).JPG";
import tattooCover3 from "../../Photo/gallery/tattoo-cover/img  (1).PNG";
import tattooCover4 from "../../Photo/gallery/tattoo-cover/img  (2).JPEG";
import tattooCover5 from "../../Photo/gallery/tattoo-cover/img  (2).PNG";
import tattooCover6 from "../../Photo/gallery/tattoo-cover/img  (3).JPEG";
import tattooCover7 from "../../Photo/gallery/tattoo-cover/img  (4).JPEG";

function Work() {
  // Данные для галереи
  const galleryData = [
    {
      id: "brows-coloring",
      title: "Окрашивание бровей",
      images: [
        { id: 1, src: brow1, alt: "Окрашивание бровей - результат 1" },
        { id: 2, src: brow2, alt: "Окрашивание бровей - результат 2" },
        { id: 3, src: brow3, alt: "Окрашивание бровей - результат 3" },
        { id: 4, src: brow4, alt: "Окрашивание бровей - результат 4" },
        { id: 5, src: brow5, alt: "Окрашивание бровей - результат 5" },
        { id: 6, src: brow6, alt: "Окрашивание бровей - результат 6" },
        { id: 7, src: brow7, alt: "Окрашивание бровей - результат 7" },
      ],
    },
    {
      id: "lash-lamination",
      title: "Ламинирование ресниц",
      images: [
        { id: 1, src: lash1, alt: "Ламинирование ресниц - результат 1" },
        { id: 2, src: lash2, alt: "Ламинирование ресниц - результат 2" },
        { id: 3, src: lash3, alt: "Ламинирование ресниц - результат 3" },
        { id: 4, src: lash4, alt: "Ламинирование ресниц - результат 4" },
        { id: 5, src: lash5, alt: "Ламинирование ресниц - результат 5" },
      ],
    },
    {
      id: "interlash",
      title: "Межресничка",
      images: [
        { id: 1, src: interlash1, alt: "Межресничка - результат 1" },
        { id: 2, src: interlash2, alt: "Межресничка - результат 2" },
        { id: 3, src: interlash3, alt: "Межресничка - результат 3" },
        { id: 4, src: interlash4, alt: "Межресничка - результат 4" },
      ],
    },
    {
      id: "tattoo-cover",
      title: "Перекрытие старого татуажа",
      images: [
        { id: 1, src: tattooCover1, alt: "Перекрытие татуажа - результат 1" },
        { id: 2, src: tattooCover2, alt: "Перекрытие татуажа - результат 2" },
        { id: 3, src: tattooCover3, alt: "Перекрытие татуажа - результат 3" },
        { id: 4, src: tattooCover4, alt: "Перекрытие татуажа - результат 4" },
        { id: 5, src: tattooCover5, alt: "Перекрытие татуажа - результат 5" },
        { id: 6, src: tattooCover6, alt: "Перекрытие татуажа - результат 6" },
        { id: 7, src: tattooCover7, alt: "Перекрытие татуажа - результат 7" },
      ],
    },
    {
      id: "lips",
      title: "Губы",
      images: [
        { id: 1, src: lips1, alt: "Перманентный макияж губ - результат 1" },
        { id: 2, src: lips2, alt: "Перманентный макияж губ - результат 2" },
        { id: 3, src: lips3, alt: "Перманентный макияж губ - результат 3" },
        { id: 4, src: lips4, alt: "Перманентный макияж губ - результат 4" },
        { id: 5, src: lips5, alt: "Перманентный макияж губ - результат 5" },
        { id: 6, src: lips6, alt: "Перманентный макияж губ - результат 6" },
        { id: 7, src: lips7, alt: "Перманентный макияж губ - результат 7" },
      ],
    },
    {
      id: "brows-pmu",
      title: "Брови перманентный макияж",
      images: [
        {
          id: 1,
          src: browsPmu1,
          alt: "Перманентный макияж бровей - результат 1",
        },
        {
          id: 2,
          src: browsPmu2,
          alt: "Перманентный макияж бровей - результат 2",
        },
        {
          id: 3,
          src: browsPmu3,
          alt: "Перманентный макияж бровей - результат 3",
        },
        {
          id: 4,
          src: browsPmu4,
          alt: "Перманентный макияж бровей - результат 4",
        },
        {
          id: 5,
          src: browsPmu5,
          alt: "Перманентный макияж бровей - результат 5",
        },
        {
          id: 6,
          src: browsPmu6,
          alt: "Перманентный макияж бровей - результат 6",
        },
        {
          id: 7,
          src: browsPmu7,
          alt: "Перманентный макияж бровей - результат 7",
        },
        {
          id: 8,
          src: browsPmu8,
          alt: "Перманентный макияж бровей - результат 8",
        },
        {
          id: 9,
          src: browsPmu9,
          alt: "Перманентный макияж бровей - результат 9",
        },
      ],
    },
  ];

  const [activeCategory, setActiveCategory] = useState(galleryData[0].id);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Определяем мобильное устройство
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Получение активной категории
  const activeCategoryData = galleryData.find(
    (cat) => cat.id === activeCategory,
  );

  // Количество изображений для отображения в зависимости от устройства
  const imagesPerView = isMobile ? 1 : Math.min(3, activeCategoryData.images.length);

  // Обработчик для тач-событий
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      handleNext();
    }

    if (isRightSwipe) {
      handlePrev();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  // Навигация карусели
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < activeCategoryData.images.length - imagesPerView) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  // Получение видимых изображений
  const getVisibleImages = () => {
    const images = activeCategoryData.images;
    
    // На мобильных показываем только текущее изображение
    if (isMobile) {
      return images.slice(currentIndex, currentIndex + 1);
    }
    
    // На десктопе показываем до 3 изображений
    const visibleCount = Math.min(3, images.length - currentIndex);
    return images.slice(currentIndex, currentIndex + visibleCount);
  };

  // Открытие модального окна
  const openModal = (imageIndex) => {
    setModalImageIndex(currentIndex + imageIndex);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden"; // Блокируем скролл
  };

  // Закрытие модального окна
  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "auto"; // Восстанавливаем скролл
  };

  // Навигация в модальном окне
  const handleModalPrev = () => {
    setModalImageIndex((prev) =>
      prev > 0 ? prev - 1 : activeCategoryData.images.length - 1,
    );
  };

  const handleModalNext = () => {
    setModalImageIndex((prev) =>
      prev < activeCategoryData.images.length - 1 ? prev + 1 : 0,
    );
  };

  // Закрытие по Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") closeModal();
    };

    if (isModalOpen) {
      window.addEventListener("keydown", handleEscape);
    }

    return () => {
      window.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  // Сброс индекса при смене категории
  useEffect(() => {
    setCurrentIndex(0);
  }, [activeCategory]);

  // Расчет количества индикаторов
  const getIndicatorsCount = () => {
    const totalImages = activeCategoryData.images.length;
    if (isMobile) {
      return totalImages; // На мобильных по одному индикатору на каждое фото
    }
    return Math.max(1, totalImages - imagesPerView + 1);
  };

  return (
    <div className="work" id="Work">
      <div className="heading">
        <Title title="Галерея работ" translate="Gallery" />
      </div>

      {/* Категории */}
      <div className="gallery-categories">
        {galleryData.map((category) => (
          <button
            key={category.id}
            className={`category-btn ${activeCategory === category.id ? "active" : ""}`}
            onClick={() => setActiveCategory(category.id)}
          >
            <span>{category.title}</span>
          </button>
        ))}
      </div>

      {/* Заголовок категории */}
      <h3 className="category-title">{activeCategoryData.title}</h3>

      {/* Карусель */}
      <div className="carousel-container">
        <button
          className="carousel-btn prev"
          onClick={handlePrev}
          disabled={currentIndex === 0}
          aria-label="Предыдущие фото"
        >
          ←
        </button>

        <div
          className="carousel"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="carousel-track">
            {getVisibleImages().map((image, index) => (
              <div
                key={`${image.id}-${currentIndex}`}
                className="gallery-card"
                onClick={() => openModal(index)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === "Enter" && openModal(index)}
                aria-label={`Открыть фото ${index + 1} в категории ${activeCategoryData.title}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="image-overlay">
                  <p className="image-title">{activeCategoryData.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          className="carousel-btn next"
          onClick={handleNext}
          disabled={
            currentIndex >= activeCategoryData.images.length - imagesPerView
          }
          aria-label="Следующие фото"
        >
          →
        </button>
      </div>

      {/* Индикаторы */}
      <div className="carousel-indicators">
        {Array.from({ length: getIndicatorsCount() }).map((_, index) => (
          <button
            key={index}
            className={`indicator ${currentIndex === index ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Перейти к ${isMobile ? 'фото' : 'группе фото'} ${index + 1}`}
          />
        ))}
      </div>

      {/* Модальное окно для просмотра */}
      {isModalOpen && (
        <div
          className={`modal-overlay ${isModalOpen ? "open" : ""}`}
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label="Просмотр фотографии"
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={closeModal}
              aria-label="Закрыть просмотр"
            >
              ×
            </button>

            <img
              src={activeCategoryData.images[modalImageIndex]?.src}
              alt={activeCategoryData.images[modalImageIndex]?.alt}
              className="modal-image"
            />

            <button
              className="modal-nav prev"
              onClick={handleModalPrev}
              aria-label="Предыдущее фото"
            >
              ←
            </button>

            <button
              className="modal-nav next"
              onClick={handleModalNext}
              aria-label="Следующее фото"
            >
              →
            </button>

            <div className="image-counter">
              {modalImageIndex + 1} / {activeCategoryData.images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Work;